'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_ju_Locale$$anon$1() {
}
export { $c_ju_Locale$$anon$1 as $c_ju_Locale$$anon$1 };
$p = $c_ju_Locale$$anon$1.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_ju_Locale$$anon$1;
/** @constructor */
function $h_ju_Locale$$anon$1() {
}
export { $h_ju_Locale$$anon$1 as $h_ju_Locale$$anon$1 };
$h_ju_Locale$$anon$1.prototype = $p;
$p.gz = (function(x) {
  if ((x !== null)) {
    if ((x.ad === "")) {
      return true;
    }
    return true;
  }
  return false;
});
$p.gt = (function(x, default$1) {
  if ((x !== null)) {
    var x11 = x.ac;
    var x12 = x.ad;
    if ((x12 === "")) {
      return x11;
    }
    return ((x11 + "-") + x12);
  }
  return default$1.j(x);
});
$p.de = (function(x) {
  return this.gz(x);
});
$p.cr = (function(x, default$1) {
  return this.gt(x, default$1);
});
var $d_ju_Locale$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Locale$$anon$1, "java.util.Locale$$anon$1", ({
  nb: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_ju_Locale$$anon$1 as $d_ju_Locale$$anon$1 };
